<script setup>
import { clone } from 'lodash';
import { ref } from 'vue';
import SelectCifra from './SelectCifra.vue';

/**
 * Componente para in input donde se pueden ir poniendo tags
 */

const props = defineProps({
  inputName: { type: String, required: true },
  options: { type: Array, default: () => ([]) },
  modelValue: { type: Array, default: () => ([]) },
});

const emits = defineEmits(['update:modelValue']);

const modelInterno = ref(clone(props.modelValue));

function addTag(newTag) {
  modelInterno.value.push(newTag);
  emits('update:modelValue', modelInterno.value);
}

</script>

<template>
  <input type="hidden" :name="inputName" :value="modelInterno?.join(',')">
  <SelectCifra
    v-model="modelInterno"
    :opciones="options"
    :multiple="true"
    :permite-etiquetas="true"
    @nueva-etiqueta="addTag"
  />
</template>
